import { getJson, postJson, putJson } from 'utils/http';

import { OrgDashboardApiIntegrationJob } from './types/OrgDashboardApiIntegrationJob';
import { OrgDashboardApiIntegrationProvider } from './types/OrgDashboardApiIntegrationProvider';
import { OrgDashboardApiJob } from './types/OrgDashboardApiJob';

export function fetchJob(
  orgId: string,
  jobId: string,
): Promise<OrgDashboardApiJob> {
  return getJson<{ job: OrgDashboardApiJob }>(
    `/data/orgdashboard/${orgId}/jobs/${jobId}`,
  ).then(({ job }) => job);
}

export async function createJob(
  orgId: string,
  payload: Record<string, any>, // eslint-disable-line @typescript-eslint/no-explicit-any
): Promise<{
  listings: OrgDashboardApiJob[];
  requiresPayment: boolean;
}> {
  const { jobs: listings, requiresPayment } = await postJson<{
    jobs: OrgDashboardApiJob[];
    requiresPayment: boolean;
  }>(`/data/orgdashboard/${orgId}/jobs`, payload);

  return { listings, requiresPayment };
}

export function validateJob(
  orgId: string,
  payload: Record<string, any>, // eslint-disable-line @typescript-eslint/no-explicit-any
): Promise<void> {
  return postJson(`/data/orgdashboard/${orgId}/jobs-validation`, payload);
}

export function updateJob(
  orgId: string,
  payload: Record<string, any>, // eslint-disable-line @typescript-eslint/no-explicit-any
): Promise<{
  job: OrgDashboardApiJob;
  requiresPayment: boolean;
  hasInvoice: true;
}> {
  return putJson(`/data/orgdashboard/${orgId}/jobs/${payload.id}`, payload);
}

export function getIntegrationJobs(
  orgId: string,
  type: OrgDashboardApiIntegrationProvider,
): Promise<{
  jobs: Array<OrgDashboardApiIntegrationJob>;
  hasError: boolean;
}> {
  const url = `/data/orgdashboard/${orgId}/${type}/jobs`;
  return getJson(url);
}
